<template>
  
    <div id="know_intro_wrapper" class="min-vh-100 d-flex flex-column align-items-center justify-content-center">
      <span role="heading" class="text-center guide-text-header d-inline-block px-3 py-1 ">{{ $t(iKey('know_section', 'know', 'label')) }}</span>
     
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12">
          
          <h2 class="h1 text-center">{{ $t(iKey('know_section', 'know', 'headline')) }}</h2>
          <div class="d-flex justify-content-center mt-4">
          <ol v-for="i in know_section" :key="i.id">
              <li class="explainer2" v-for="(q, index) in i.value.questions" :key="index">{{ $t(iKey('know_section', 'know', 'question_' + index)) }}</li>
          </ol>
          </div>
          </div>
        </div>
      </div>
    </div>
  
</template>

<script>

export default {
  name: 'KnowIntro',
  props: [
    'know_section',
  ],
  mounted(){
    // var dur = this.windowHeight
    // const scene = this.$scrollmagic.scene({
    //     triggerElement: '#know_intro_wrapper',
    //     triggerHook: 0,
    //     duration: dur
    // })
    // this.$scrollmagic.addScene(
    //   scene
    //       .setPin('#know_intro_wrapper')
    //       //.addIndicators({name: 'Scene 3'})
    // )  
  }
}
</script>

<style scoped>
#know_intro_wrapper {
  background-color: rgba(150, 140, 130, 0.1);
  background-image: url('../../assets/images/photocopy-bg.jpg');
  background-size: cover;
  background-blend-mode: multiply;
}
.guide-text-header {
  color: #fff;
  background-color: #382e2b;
}
h2 {
  color: #ed7530;
}
</style>